import styled from 'styled-components';
import type { DynamicTableDurationUnitConfig } from '../../config/types';

type Props = {
  id: string;
  label: string;
  value: string;
  unitValue: string;
  defaultUnit?: string;
  units: DynamicTableDurationUnitConfig[];
  disabled: boolean;
  onValueChange: (value: string) => void;
  onUnitChange: (value: string) => void;
  onFocus: () => void;
};

const DurationFields = styled.div`
    box-sizing: border-box;
    display: grid;
    grid-template-columns: minmax(5rem, 1fr) max-content;
    align-items: center;
    gap: 8px;
    min-width: 220px;
    padding: 2px 8px;

    .govuk-form-group {
        margin-bottom: 0;
    }

    .govuk-input {
        box-sizing: border-box;
        width: 100%;
        max-width: none;
        min-height: 40px;
        margin: 0;
    }

    .govuk-select {
        min-width: 0;
        width: auto;
        max-width: 100%;
        margin: 0;
    }
`;

export default function DynamicTableDurationInput({
  id,
  label,
  value,
  unitValue,
  defaultUnit,
  units,
  disabled,
  onValueChange,
  onUnitChange,
  onFocus,
}: Props) {
  return (
    <DurationFields>
      <div className="govuk-form-group">
        <label className="govuk-label govuk-visually-hidden" htmlFor={id}>
          {label} number
        </label>
        <input
          className="govuk-input govuk-input--width-4"
          id={id}
          type="text"
          inputMode="numeric"
          value={value}
          disabled={disabled}
          onChange={(event) => onValueChange(event.target.value)}
          onFocus={onFocus}
        />
      </div>
      <div className="govuk-form-group">
        <label className="govuk-label govuk-visually-hidden" htmlFor={`${id}-unit`}>
          {label} unit
        </label>
        <select
          className="govuk-select"
          id={`${id}-unit`}
          value={unitValue || defaultUnit || units[0]?.value || ''}
          disabled={disabled}
          onChange={(event) => onUnitChange(event.target.value)}
          onFocus={onFocus}
        >
          {units.map((unit) => (
            <option key={unit.value} value={unit.value}>
              {unit.value}
            </option>
          ))}
        </select>
      </div>
    </DurationFields>
  );
}
